import styled from 'styled-components';
import { PlayLinkContainer } from '../../components/Link';
import { device } from '../breakpoints';
import { regularWhite, fontWeightRegular } from '../design-tokens';
import { calc } from '../helpers';
import { playFontSize } from '../typography/helpers';
import { playFocus } from '../utils.styles';

export const PromotionItemWrapper = styled.article`
    position: relative;
    display: inline-block;
    margin-bottom: 5px;

    ${calc('width', '50% - 2.5px', '49.4%')};

    @media ${device.GteSmall} {
        ${calc('width', '33.3% - 2.5px', '32.7%')};
    }

    @media ${device.GteLarge} {
        ${calc('width', '25% - 3.75px', '24.7%')};
    }
`;

export const ItemLink = styled(PlayLinkContainer)`
    display: block;
    text-decoration: none;
    &:hover {
        cursor: pointer;

        span {
            border-bottom: 1px solid ${regularWhite};
        }
    }
    ${playFocus()};
`;

export const ItemCaption = styled.h2`
    position: absolute;
    top: 50%;
    left: 0;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    color: ${regularWhite};
    font-weight: ${fontWeightRegular};
    text-align: center;
    width: 100%;
    box-shadow: 0 0 black;
    ${playFontSize(1.8)};
    line-height: 1.2;
    margin: 0 0 0.1em 0;

    @media ${device.GteMedium} {
        ${playFontSize(2)};
    }

    @media ${device.GteLarge} {
        ${playFontSize(2.2)};
    }
`;
